import type { EntityViewProps } from '../../types';
import { ArticulosEntity } from './ArticulosEntity';

export function ProductosEntity(props: EntityViewProps) {
  return <ArticulosEntity {...props} cotizable="SI" entitySingular="Producto" />;
}
